// React
import { useState, useContext, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

// Global Context
import { GlobalContext } from '../../../contexts/Global';

// Kendo
import { Button, Chip } from "@progress/kendo-react-buttons";
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { orderBy } from "@progress/kendo-data-query";
import Date from '../../../components/Grid/Cell/Date';

// Components
import Title from '../../../components/Page/Title';
import StatusDot from '../../../components/Grid/Cell/StatusDot';

// Constants
import { MEMBER_CLASSES } from '../../../constants';

const MembersList = () => {
    const navigate = useNavigate();
    const { user } = useContext(GlobalContext);
    const [ members, setMembers ] = useState([]);
    const [ sort, setSort ] = useState([
        {
            field: 'agreement_date',
            dir: 'desc',
        },
    ]);

    useEffect(()=> {
        fetch(process.env.REACT_APP_API_BASE_URL + "/admin/cers/members", {
            headers: {
                Authorization: 'Bearer ' + user.access_token
            }
        })
            .then((response) => response.json())
            .then((response) => {
                setMembers(response.data.members);
            });
    }, [ ])

    const Status = (props) => {
        let label = '-';
        let themeColor = 'base';
        switch (props.dataItem.status) {
            case 'active':
                label = 'Attivo';
                themeColor = 'success';
                break;

            case 'pending':
                label = 'In attesa';
                themeColor = 'warning';
                break;

            default:
                label = '-';
                themeColor = 'base';
        }

        return (
            <td style={{ textAlign: 'center' }}>
                <Chip text={ label } themeColor={ themeColor } rounded={ null } />
            </td>
        )
    }

    const Class = (props) => {
        return (
            <td>{ MEMBER_CLASSES.find((e) => e.value == props.dataItem.class).label }</td>
        )
    }

    const ConventionalAreas = (props) => {
        if (!props.dataItem.conventional_areas || props.dataItem.conventional_areas.length === 0) {
            return <td>-</td>;
        }

        return (
            <td>
                <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                    { props.dataItem.conventional_areas.map((area, index) => (
                        <Chip
                            key={ index }
                            text={ area.main_comune }
                            rounded={ null }
                        />
                    )) }
                </div>
            </td>
        );
    }

    const Actions = (props) => {
        return (
            <td>
                <Button className="buttons-container-button" icon="pencil" onClick={ () => openMember(props.dataItem.id) }></Button>
            </td>
        )
    }

    const openMember = (member_id) => {
        navigate("/cers/member/" + member_id);
    }

    return (
        <>
            <Title>
                <div>
                    Lista utenti <small>({ members.length })</small>
                </div>
                <Link to="/cers/member">
                    <Button rounded={ null } size="large" themeColor="primary">Nuovo membro</Button>
                </Link>
            </Title>

            <div className="section">
                <Grid
                    data={ orderBy(members, sort) }
                    scrollable="none"
                    sortable={ true }
                    sort={ sort }
                    onSortChange={(e) => {
                        setSort(e.sort);
                    }}
                >
                    <GridColumn field="id" title="Id" width="40px" />
                    <GridColumn field="class" title="Classe" width="100px" cell={ Class } />
                    <GridColumn field="agreement_date" title="Data stipula" width="100px" cell={ Date} />
                    <GridColumn field="conventional_areas" title="Cabine primarie" width="200px" sortable={ false } cell={ ConventionalAreas } />
                    <GridColumn field="first_name" title="Nome" />
                    <GridColumn field="last_name" title="Cognome" />
                    <GridColumn field="has_personal_data" title="Dati anagrafici" width="80px" cell={ StatusDot } />
                    <GridColumn field="has_contact_data" title="Recapiti" width="80px" cell={ StatusDot } />
                    <GridColumn field="has_pod_data" title="POD" width="80px" cell={ StatusDot } />
                    <GridColumn field="has_cadastral_data" title="Catasto" width="80px" cell={ StatusDot } />
                    <GridColumn field="has_id_document" title="Documento" width="80px" cell={ StatusDot } />
                    <GridColumn field="has_payment_proof" title="Pagamento" width="80px" cell={ StatusDot } />
                    <GridColumn field="has_required_declarations" title="Dichiarazioni" width="80px" cell={ StatusDot } />
                    <GridColumn field="has_mandate" title="Mandato" width="80px" cell={ StatusDot } />
                    <GridColumn field="has_signed_contract" title="Contratto" width="80px" cell={ StatusDot } />
                    <GridColumn field="is_gse" title="GSE" width="80px" cell={ StatusDot } />
                    <GridColumn field="actions" title="&nbsp;" width="60px" filterable={ false } cell={ Actions } />
                </Grid>
            </div>
        </>
    );
}

export default MembersList;
